import React from 'react';
import { BsLinkedin, BsGithub,BsInstagram } from 'react-icons/bs';

const SocialMedia = () => (
  <div className="app__social">
    <a href='https://www.linkedin.com/in/yashwantg-07/' target="_blank" rel="noopener noreferrer">
      <div>
        <BsLinkedin />
      </div>
    </a>
    <a href='https://github.com/Yashwant-G' target="_blank" rel="noopener noreferrer">
      <div>
        <BsGithub />
      </div>
    </a>
    <a href='https://www.instagram.com/_yashwant07/' target="_blank" rel="noopener noreferrer">
      <div>
        <BsInstagram />
      </div>
    </a>
  </div>
);

export default SocialMedia;
